export const name = "REGEXP_EXTRACT_ALL";
export const summary = `Produces an array of all substrings that match a regular expression.`;
export const reference = `
## REGEXP_EXTRACT_ALL

Produces an array of all substrings that match a regular expression.

\`\`\`
REGEXP_EXTRACT_ALL(value, regexp)
\`\`\`

### Description

Returns an array of all substrings of \`value\` that match the re2 regular expression, \`regexp\`. Returns an empty array if there is no match.

If the regular expression contains a capturing group (\`(...)\`), and there is a match for that capturing group, that match is added to the results.

The \`REGEXP_EXTRACT_ALL\` function only returns non-overlapping matches. For example, using this function to extract \`ana\` from \`banana\` returns only one substring, not two.

Returns an error if:

- The regular expression is invalid
- The regular expression has more than one capturing group


### Return type

\`ARRAY<STRING>\` or \`ARRAY<BYTES>\`


### Examples



\`\`\`
SELECT REGEXP_EXTRACT_ALL('Try \`func(x)\` or \`func(y)\`', '\`(.+?)\`') AS example

/*--------------------*
 | example |
 +--------------------+
 | [func(x), func(y)] |
 *--------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
